// Anything carrying thumbnail paths — ImageObject, question attachments, …
interface ThumbSource {
  documentUrl?: string
  paths?: { thumb?: string; thumbs?: Record<string, string> }
}

// Resolve a usable image URL from the API image object.
// Thumbnails live under image.paths.thumbs[<requested id>]; image.paths.thumb is
// the fallback. Request thumbnails by adding `thumb[<id>][style]=...` to the query.
export function imageThumb(
  image: ThumbSource | null | undefined,
  id = 'main',
  fallback = '/img/placeholder.svg'
): string {
  return (
    image?.paths?.thumbs?.[id] ||
    image?.paths?.thumb ||
    image?.documentUrl ||
    fallback
  )
}
